<template>
  <div class="col-12">
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <input hidden type="text" v-model="Fields.id" id="id" name="id" />
        <input
          hidden
          type="text"
          v-model="Fields.usuario_id"
          id="id"
          name="id"
        />
        <div class="form-group">
          <label for="cep" class="font-weight-bold"> CEP: </label>
          <input
            type="text"
            v-model="Fields.cep"
            @blur="consultCep()"
            id="cep"
            name="cep"
            v-mask="'#####-###'"
            aria-describedby="CEP para Cadastro"
            placeholder="Digite seu CEP"
            class="form-control"
            @input="ErrorMessages.cep = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cep !== null"
          >
            {{ ErrorMessages.cep }}
          </p>
        </div>
      </div>
      <div class="col-lg-8 col-md-6">
        <div class="form-group">
          <label for="address" class="font-weight-bold"> Endereço: </label>
          <input
            type="text"
            v-model="Fields.address"
            id="address"
            name="address"
            aria-describedby="Endereço para Cadastro"
            placeholder="Digite seu Endereço"
            class="form-control"
            @input="ErrorMessages.address = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidAddress)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.address !== null"
          >
            {{ ErrorMessages.address }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="number" class="font-weight-bold"> Número: </label>
          <input
            type="text"
            v-model="Fields.number"
            id="number"
            name="number"
            aria-describedby="Número para Cadastro"
            placeholder="Digite seu Número"
            class="form-control"
            @input="ErrorMessages.number = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.number !== null"
          >
            {{ ErrorMessages.number }}
          </p>
        </div>
      </div>
      <div class="col-lg-8 col-md-6">
        <div class="form-group">
          <label for="complement" class="font-weight-bold">
            Complemento (opcional):
          </label>
          <input
            type="text"
            v-model="Fields.complement"
            id="complement"
            name="complement"
            aria-describedby="Complemento para Cadastro"
            placeholder="Digite seu Complemento"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <div class="form-group">
          <label for="neighborhood" class="font-weight-bold"> Bairro: </label>
          <input
            type="text"
            v-model="Fields.neighborhood"
            id="neighborhood"
            name="neighborhood"
            aria-describedby="Bairro para cadastro"
            placeholder="Digite o bairro"
            class="form-control"
            @input="ErrorMessages.neighborhood = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidNeighborhood)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.neighborhood !== null"
          >
            {{ ErrorMessages.neighborhood }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="city_name" class="font-weight-bold"> Cidade: </label>
          <v-select
            disabled
            class="no-search"
            label="nome"
            placeholder="Selecione a cidade"
            v-model="Fields.city_name"
            :options="getCities"
            :reduce="(city) => city.id"
            @input="ErrorMessages.city_name = null"
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.city_id !== null"
          >
            {{ ErrorMessages.city_id }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="cadastroEstado" class="font-weight-bold"> Estado: </label>
          <v-select
            disabled
            id="state_id"
            name="state_id"
            placeholder="Selecione o estado da empresa"
            label="nome"
            autocomplete="nope"
            class="no-search"
            v-model="Fields.state_id"
            @input="ErrorMessages.state_id = null"
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.state_id !== null"
          >
            {{ ErrorMessages.state_id }}
          </p>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-success text-white my-3"
      @click="register()"
    >
      Salvar endereço
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'Endereco',
  mixins: [makeToast],
  data() {
    return {
      Fields: {
        cep: null,
        state_id: null,
        neighborhood: null,
        number: null,
        city_id: null,
        city_name: null,
        address: null,
        complement: null,
      },
      ErrorMessages: {
        cep: null,
        state_id: null,
        neighborhood: null,
        city_id: null,
        address: null,
        number: null,
        complement: null,
      },
      cepConsult: {
        consulted: false,
        isValidAddress: true,
        isValidNeighborhood: true,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters('general', ['getCities']),
    ...mapState(['token', 'dadosUsuario', 'estados', 'cidades', 'getAdress']),
  },
  created() {
    this.Fields.id = this.dadosUsuario.informacoes.id;
    this.buscarCidades()
  },
  methods: {
    register() {
      this.$store.dispatch('startLoader');

      this.$store
        .dispatch('client/registeraddress', this.Fields)
        .then(() => {
          this.buscarEndereco();
          this.makeToast('Sucesso!', 'Endereço atualizado com sucesso!');
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Parece que houve um erro no cadastro, tente novamente mais tarde',
            'danger'
          );
        })
        .finally(() => {
            this.loading = false;
            this.$store.dispatch("endLoader");
          });
    },
    buscarCidades() {
      this.$store
        .dispatch("general/getAllCities", this.dadosUsuario.informacoes.id)
        .then(() => {
        })
        .finally(() => {
          this.buscarEndereco();
        })
    },
    buscarEndereco() {
      this.$store
        .dispatch('client/getAdress', this.dadosUsuario.informacoes.id)
        .then(async (response) => {
          this.Fields.cep = response.data.cep;
          this.Fields.address = response.data.endereco;
          this.Fields.neighborhood = response.data.bairro;
          this.Fields.city_id = response.data.cidade_id;
          this.Fields.state_id = response.data.uf;
          this.Fields.number = response.data.numero;
          this.Fields.complement = response.data.complemento;
          this.validateCepResults(response.data);
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        });
    },
    consultCep() {
      if (!this.loading && this.Fields.cep.length === 9) {
        this.loading = true;
        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('user/consultCep', this.Fields.cep)
          .then(async (response) => {
            this.validateCepResults(response.data);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch('endLoader');
          });
      }

      if (this.Fields.cep.length === 0) {
        this.cepConsult.consulted = false;
        this.Fields.address = null;
        this.Fields.neighborhood = null;
        this.Fields.city_id = null;
        this.Fields.state_id = null;
      }
    },
    validateCepResults(result) {
      this.cepConsult.consulted = true;
      this.cepConsult.isValidAddress = !!result.logradouro;
      this.cepConsult.isValidNeighborhood = !!result.bairro;
      this.Fields.address = result.logradouro || result.endereco || null;
      this.Fields.neighborhood = result.bairro || null;
      this.Fields.city_name = result.localidade || null;
      this.Fields.city_id = result.cidade_id || null;
      this.Fields.state_id = result.uf || null;
      this.ErrorMessages.address = null;
      this.ErrorMessages.neighborhood = null;
      this.ErrorMessages.city_id = null;
      this.ErrorMessages.state_id = null;
    },
  },
};
</script>
